import { render, staticRenderFns } from "./MainPropertyRow.vue?vue&type=template&id=d83f706c&scoped=true&"
import script from "./MainPropertyRow.vue?vue&type=script&lang=js&"
export * from "./MainPropertyRow.vue?vue&type=script&lang=js&"
import style0 from "./MainPropertyRow.vue?vue&type=style&index=0&id=d83f706c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83f706c",
  null
  
)

export default component.exports